import script from "./UnitInfo__sensors_name.vue?vue&type=script&lang=js"
export * from "./UnitInfo__sensors_name.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__